

























import { Mixins } from "vue-mixin-decorator";
import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { ICompany } from "@/types/company";
import { ICompanyImage } from "@/types/company_image";
import GeneralMixin from "@/mixin";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("company/adminGetMine")
  public getMyCompany!: () => void;

  @Action("company_image/adminGetList")
  public getCompanyImageList!: (company_id: number) => boolean;

  @Getter("company/single")
  public company!: ICompany;

  @Getter("company_image/list")
  public company_image!: ICompanyImage;

  @Mutation("company/clear")
  public clear!: () => void;

  @Mutation("company_image/clear")
  public clearCompanyImage!: () => void;

  // fields
  public company_id = 0;

  public async created() {
    this.clear();
    this.clearCompanyImage();
    await this.getMyCompany();
    await this.getCompanyImageList(this.company.id);
  }
}
